module.exports = {
      id: "highlights-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#highlights",
      toString: function () {
        return this.url;
      }
    }